import { i18n } from "./i18n";
import type { TravelMode } from "./types";

const SPEED_KMH: Record<TravelMode, number> = {
  plane: 800,
  train: 100,
  bus: 60,
  car: 80,
};

const FIXED_OVERHEAD_MIN: Partial<Record<TravelMode, number>> = {
  plane: 90,
};

export function estimateMinutes(
  distanceKm: number,
  mode: TravelMode | undefined,
): number | null {
  if (!mode) return null;
  if (!Number.isFinite(distanceKm) || distanceKm <= 0) return null;
  const moving = (distanceKm / SPEED_KMH[mode]) * 60;
  const overhead = FIXED_OVERHEAD_MIN[mode] ?? 0;
  return Math.round(moving + overhead);
}

export function formatDuration(minutes: number): string {
  if (!Number.isFinite(minutes) || minutes <= 0) return "";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const hUnit = i18n.t("unitH");
  const mUnit = i18n.t("unitM");
  if (h > 0 && m > 0) return `${h}${hUnit} ${m}${mUnit}`;
  if (h > 0) return `${h}${hUnit}`;
  return `${m}${mUnit}`;
}
